import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <header className="bg-white border-b border-zinc-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-zinc-100 transition-colors" data-testid="terms-back-btn">
            <ArrowLeft size={24} weight="bold" className="text-zinc-700" />
          </button>
          <h1 className="text-lg sm:text-xl font-black text-zinc-900 tracking-tight">Termini e Condizioni</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        <div className="prose prose-zinc prose-sm max-w-none">
          <p className="text-xs text-zinc-400 uppercase tracking-wider font-bold mb-6">Versione aggiornata al 5 Aprile 2026</p>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">1. Oggetto del Servizio</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            L'App "Locazione Turistica" &egrave; un servizio fornito da Sergio Battelli, titolare della ditta individuale Vita da Host (P.IVA 02903680995), con sede in Genova. La piattaforma SaaS permette la creazione, l'invio e la sottoscrizione digitale di contratti di locazione per finalit&agrave; turistiche.
          </p>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>NORMATIVA VIGENTE:</strong> Il servizio &egrave; ottimizzato per le locazioni di durata inferiore ai 30 giorni, per le quali, ai sensi del D.P.R. n. 131/1986, non sussiste l'obbligo di registrazione del contratto presso l'Agenzia delle Entrate. Sergio Battelli fornisce lo strumento tecnologico e modelli standard; l'Utente (l'Host) &egrave; l'unico responsabile della correttezza dei dati e del rispetto delle normative locali (CIN, CIR, etc.).
          </p>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">2. Modalit&agrave; di Firma (Firma Elettronica Semplice - FES)</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            Il contratto si intende validamente sottoscritto tramite tracciato grafico apposto digitalmente dal firmatario (ospite).
          </p>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>Flessibilit&agrave; del Device:</strong> La firma pu&ograve; essere apposta tramite interfaccia Touch-Screen (dito o penna digitale) oppure tramite dispositivo di puntamento (mouse o trackpad) su sistemi desktop, garantendo la massima compatibilit&agrave; con il dispositivo in uso all'ospite.
          </p>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>Valore Legale:</strong> Tale modalit&agrave; &egrave; qualificata come Firma Elettronica Semplice (FES) (Regolamento UE eIDAS e CAD). L'efficacia probatoria del documento &egrave; liberamente valutabile in giudizio.
          </p>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>Responsabilit&agrave; dell'Host:</strong> L'onere di verificare l'identit&agrave; del firmatario tramite documento di riconoscimento prima della firma ricade interamente sull'Host. Sergio Battelli non risponde dell'imputabilit&agrave; della firma in caso di contestazione.
          </p>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">3. Prova Gratuita e Abbonamenti (Mensile/Annuale)</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>7 Giorni di Trial:</strong> L'Utente dispone di 7 giorni di prova gratuita dalla registrazione.
          </p>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>Rinnovo Automatico:</strong> Se non annullato entro il termine dei 7 giorni, il sistema proceder&agrave; all'addebito automatico del piano scelto tramite Stripe.
          </p>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>Cancellazione:</strong> L'abbonamento &egrave; annullabile in qualsiasi momento con un click. L'accesso rimane garantito fino al termine del periodo pagato. Non sono previsti rimborsi per frazioni di periodo non utilizzate.
          </p>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">4. Archiviazione e Sicurezza</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>Disponibilit&agrave;:</strong> I contratti PDF sono disponibili per il download per 24 ore dalla firma. Trascorse le 24 ore, il documento viene eliminato automaticamente dal server. L'Host &egrave; tenuto a scaricare il PDF entro tale termine.
          </p>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>Log:</strong> La piattaforma conserva unicamente un registro minimale delle operazioni (nome, iniziale cognome, data, numero ospiti) per finalit&agrave; di storico dell'Host.
          </p>
          <p className="text-sm text-zinc-600 leading-relaxed mb-4">
            <strong>Cessazione:</strong> In caso di disdetta, l'Utente ha 30 giorni per scaricare i propri dati. Successivamente, i dati potranno essere eliminati definitivamente (GDPR).
          </p>

          <h2 className="text-base font-black text-zinc-900 mt-8 mb-3">5. Limitazioni di Responsabilit&agrave;</h2>
          <p className="text-sm text-zinc-600 leading-relaxed mb-2">
            Sergio Battelli / Vita da Host non &egrave; responsabile per:
          </p>
          <ul className="list-disc list-inside text-sm text-zinc-600 space-y-1 mb-4 pl-2">
            <li>Dispute tra Host e Ospite relative al contenuto del contratto.</li>
            <li>Errori di compilazione dell'Utente o mancato rispetto degli obblighi amministrativi (AlloggiatiWeb, Tassa di Soggiorno).</li>
            <li>Malfunzionamenti tecnici del dispositivo dell'ospite che rendano la firma graficamente irregolare.</li>
          </ul>

          <div className="mt-10 pt-8 border-t border-zinc-200">
            <p className="text-xs text-zinc-400 text-center">
              &copy; 2026 Sergio Battelli &mdash; Vita da Host (P.IVA 02903680995) &mdash; Genova
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
